import BaseAPI from './base.api';

export interface FeatureFeedbackPayload {
  userEmail: string;
  featureName: string;
  value: 'like' | 'dislike';
  source: 'web';
  metadata: Record<string, string>;
}

export default class FeatureFeedbackAPI extends BaseAPI {
  postFeedback = async (payload: FeatureFeedbackPayload): Promise<void> => {
    await this.API.post('feature-feedback', payload, {
      params: { customerId: this.customerId },
    });
  };
}
